import { render, staticRenderFns } from "./GroupingRuleCard.vue?vue&type=template&id=71d83cee&scoped=true"
import script from "./GroupingRuleCard.vue?vue&type=script&lang=js"
export * from "./GroupingRuleCard.vue?vue&type=script&lang=js"
import style0 from "./GroupingRuleCard.vue?vue&type=style&index=0&id=71d83cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d83cee",
  null
  
)

export default component.exports